export const SITE_ORIGIN = "https://rencamp.earthboundmartian.com";
export const SITE_NAME = "RenCamp";
export const SITE_TAGLINE = "Plan the faire. Sleep nearby.";
export const SITE_DESCRIPTION =
  "A free map of renaissance faires, historical festivals, fairy fests, mermaid meets, and pirate weekends — with dates, camping notes, and trip planning.";
export const ORG_ORIGIN = "https://earthboundmartian.com";
export const ORG_NAME = "Earthbound Martian, LLC";
export const CONTACT_EMAIL = "rencamp@earthboundmartian.com";
